import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/reports/sales/microscope",
    name: "reports-sales-microscope",
    component: () => import("./views/SalesMicroscope.vue"),
    meta: {
      requiresAuth: true,
      requiredRoles: [],
      requiredGroups: [],
    },
  },
];
